var _style, _polygon, _g, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitTrailerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 24.3",
    style: {
      enableBackground: "new 0 0 22 24.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#3B66B0;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2.5,7 2.5,13.8 4.2,13.8 4.2,7.8 5.8,7.8 5.8,13.8 7.5,13.8 7.5,7.8 9.2,7.8 9.2,13.8 10.7,13.8  10.7,7.8 12.4,7.8 12.4,13.8 14.1,13.8 14.1,7.8 15.8,7.8 15.8,13.8 17.5,13.8 17.5,7 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.5,19.1v-0.6h-1v0.6H4.4v-0.6h-1v0.6H0.8v0.7v0.3v0.5v0.1v0.8h1.8c0,1.1,0.9,2,2,2s2-0.9,2-2h0.3 c0,1.1,0.9,2,2,2s2-0.9,2-2h0.4v0.7v0.1v0.4c0,0.1,0.1,0.2,0.2,0.2h3.2c0.1,0,0.2-0.1,0.2-0.2v-0.4l0,0l0,0v-0.7h0.4v-0.9h-4.7 c-0.1-0.2-0.2-0.4-0.4-0.5h10.2v2.7h0.9v-2.7v-0.5v-0.5h-5.8V19.1z M12.1,21.4H14v0.5h-1.9V21.4z M2.8,20.6H1.7v-0.5h1.5 C3,20.2,2.9,20.4,2.8,20.6z M4.6,22.3c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.2-0.7,0.6-0.9c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1 c0.3,0.1,0.6,0.5,0.6,0.9C5.5,21.9,5.1,22.3,4.6,22.3z M7.1,20.6H6.4c-0.1-0.2-0.2-0.4-0.4-0.5h1.5C7.3,20.2,7.2,20.4,7.1,20.6z  M8.8,22.3c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.2-0.7,0.6-0.9c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.3,0.1,0.6,0.5,0.6,0.9 C9.8,21.9,9.4,22.3,8.8,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.6,21.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4S5,21.6,5,21.4C5,21.2,4.8,21.1,4.6,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,21.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4C9.2,21.3,9,21.1,8.8,21.1z"
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17.5,11.4 17.5,16.8 15.8,16.8 15.8,11.6 14.1,13.3 14.1,16.8 12.4,16.8 12.4,14.4 12.3,14.4  12.3,14.4 10.7,12.8 10.7,16.8 9.2,16.8 9.2,11.3 8.7,10.8 7.5,10.8 7.5,16.8 5.8,16.8 5.8,10.8 4.2,10.8 4.2,16.8 2.5,16.8 2.5,10  7.9,10 6.8,8.9 7.5,8.3 0.8,8.3 0.8,18.5 19.2,18.5 19.2,11.4 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0.8,4.7 8.5,4.7 7.2,6.1 8.4,7.2 11.7,3.9 8.4,0.5 7.2,1.7 8.5,3 0.8,3 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "20.7,8.3 12.5,8.3 13.8,6.9 12.6,5.8 9.3,9.1 12.6,12.5 13.8,11.3 12.5,10 20.7,10 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitTrailerIcon);
export default __webpack_public_path__ + "static/media/split-trailer-icon.2ea789cee7d810aafee8cbc01baf4b6a.svg";
export { ForwardRef as ReactComponent };